module.exports = __webpack_public_path__ + "assets/log.7798bf59.svg";